export default __webpack_public_path__ + "static/media/selected-plan-icon.adc7a6d8.svg";